module.exports = __webpack_public_path__ + "static/media/SO.0e12e99f.png";